export { RelatedArticles as default } from './RelatedArticles';
